export default __webpack_public_path__ + "static/media/Tunic of Lunacy.55166119.jpg";